<template>
  <div id="dashboard-yield">
    <WizardAlert section="dashboardYield" alertClass="my-4">
      <template v-slot:text>
        <p>
          {{ $t('views.dashboardDetail.yield.wizard.a1') }}
        </p>
        <p>
          {{ $t('views.dashboardDetail.yield.wizard.a2') }}
        </p>
      </template>
    </WizardAlert>

    <v-card
      class="px-5 py-2 mt-4 mb-0 elevation-0"
      :class="{ 'sticky-filters': user.preferences.stickyFilters }"
    >
      <PositionsFiltersAndViewMode
        ref="positionsFilters"
        type="position"
        :positionType.sync="positionType"
        showZeroPositions
        @filterPositions="filterPositions"
      />
    </v-card>

    <SomePositionIncomplete />

    <!-- <v-row>
      <v-col cols="12" md="3" class="mt-4 py-0">
        <v-row>
          <v-col cols="12" md="12" class="py-0 mb-4">
            <SummaryTotalPortfolio ref="totalPortfolio" />
          </v-col>
          <v-col cols="12" md="12" class="py-0 mb-4">
            <SummaryTotalCost ref="totalCost" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="3" class="mt-4 py-0">
        <v-col cols="12" md="12" class="py-0 mb-4">
          <SummaryTotalProfit
            ref="totalProfit"
            :headerLink="$t('common.seeDetail')"
            @headerLinkClicked="$emit('goTab', 2)"
          />
        </v-col>
        <v-col cols="12" md="12" class="py-0 mb-4">
          <SummaryTotalDividends
            ref="totalDividends"
            :headerLink="$t('common.seeDetail')"
            @headerLinkClicked="$emit('goTab', 3)"
          />
        </v-col>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col cols="12" lg="12" class="mt-4 py-0">
        <SummaryPortfolioPerformance ref="portfolioPerformancePl" type="pl" />
      </v-col>

      <v-col cols="12" lg="12" class="mt-4 py-0">
        <PositionsHdayTable :type="positionType" :filters="filters" :showZeroPositions="true" />
      </v-col>

      <v-col cols="12" lg="12" class="mt-0 py-0">
        <SummaryTotals ref="summaryTotalsTable" @goTab="(item) => $emit('goTab', item)" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import PositionsFiltersAndViewMode from '@/views/components/common/positions/PositionsFiltersAndViewMode'
import WizardAlert from '@/views/components/common/WizardAlert'
// import SummaryTotalPl from '@/views/components/dashboardDetail/summary/SummaryTotalPl'
// import SummaryTotalPortfolio from '@/views/components/dashboardDetail/summary/SummaryTotalPortfolio'
// import SummaryTotalDividends from '@/views/components/dashboardDetail/summary/SummaryTotalDividends'
// import SummaryPortfolioGrowth from '@/views/components/dashboardDetail/summary/SummaryPortfolioGrowth'
// import SummaryTotalCost from '@/views/components/dashboardDetail/summary/SummaryTotalCost'
// import SummaryTotalProfit from '@/views/components/dashboardDetail/summary/SummaryTotalProfit'
import SummaryPortfolioPerformance from '@/views/components/dashboardDetail/summary/SummaryPortfolioPerformance'
import PositionsHdayTable from '@/views/components/dashboardDetail/summary/PositionsHdayTable'
import SummaryTotals from '@/views/components/dashboardDetail/summary/SummaryTotals'
import SomePositionIncomplete from '@/views/components/common/positions/SomePositionIncomplete.vue'

export default {
  components: {
    PositionsFiltersAndViewMode,
    WizardAlert,
    // SummaryTotalPl,
    // SummaryTotalPortfolio,
    // SummaryTotalDividends,
    // SummaryPortfolioGrowth,
    // SummaryTotalCost,
    // SummaryTotalProfit,
    SummaryPortfolioPerformance,
    PositionsHdayTable,
    SummaryTotals,
    SomePositionIncomplete,
  },
  data() {
    return {
      positionType: null,
      filters: {},
    }
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    positionType: {
      async handler() {
        if (this.positionType) await this.updateFilters()
      },
    },
  },
  async mounted() {
    this.positionType = get(this.user, 'preferences.defaultPositionsNeCash', null)
      ? 'allNeCash'
      : 'all'
  },
  methods: {
    async updateFilters() {
      if (this.$refs.positionsFilters) await this.$refs.positionsFilters.updateFilters()
      this.init()
    },
    async init() {
      const filters = JSON.parse(JSON.stringify(this.filters))
      const type = this.positionType

      if (this.$refs.totalPortfolio) this.$refs.totalPortfolio.load({ filters, type })
      // if (this.$refs.portfolioGrowth) this.$refs.portfolioGrowth.load({ filters, type })
      if (this.$refs.totalCost) this.$refs.totalCost.load({ filters, type })
      if (this.$refs.totalProfit) this.$refs.totalProfit.load({ filters, type })
      // if (this.$refs.totalPl) this.$refs.totalPl.load({ filters, type })
      if (this.$refs.totalDividends) this.$refs.totalDividends.load({ filters, type })

      if (this.$refs.portfolioPerformancePl)
        this.$refs.portfolioPerformancePl.load({ filters, positionType: type })

      if (this.$refs.summaryTotalsTable)
        this.$refs.summaryTotalsTable.load({ filters, positionType: type })
    },
    async filterPositions(filters) {
      this.filters = JSON.parse(JSON.stringify(filters))
      this.init(filters)
    },
  },
}
</script>
